import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Page = styled.div`
  min-height: 100vh;
  width: 100%;
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  background: #f6f8fb;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`

export const Sidebar = styled.aside`
  position: sticky;
  top: 0;
  height: 100vh;
  padding: 24px 20px 20px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e6e9ee;
  background: #fff;

  @media (max-width: 860px) {
    position: static;
    height: auto;
    border-right: 0;
    border-bottom: 1px solid #e6e9ee;
  }

  @media (max-width: 720px) {
    padding: 12px 12px 10px;
  }
`

export const BrandBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

export const BrandLink = styled(Link)`
  display: inline-flex;
  align-items: center;
`

export const Logo = styled.img`
  width: 132px;
  height: auto;
`

export const AdminBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 9px;
  border: 1px solid rgba(233, 0, 0, 0.15);
  border-radius: 999px;
  background: #fff2f2;
  color: #d90000;
  font-size: 11px;
  font-weight: 800;

  svg {
    font-size: 10px;
  }
`

export const SidebarBody = styled.div`
  flex: 1;
  margin-top: 46px;

  @media (max-width: 860px) {
    margin-top: 24px;
  }

  @media (max-width: 720px) {
    margin-top: 10px;
  }
`

export const SidebarLabel = styled.div`
  margin-bottom: 9px;
  color: #2e3440;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`

export const SidebarText = styled.p`
  margin: 0;
  color: #7b8493;
  font-size: 12px;
  line-height: 1.65;
`

export const SidebarFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding-top: 18px;
  border-top: 1px solid #edf0f4;

  @media (max-width: 720px) {
    display: none;
  }
`

export const SidebarLink = styled(Link)`
  min-height: 42px;
  padding: 0 11px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 9px;
  color: #515866;
  font-size: 13px;
  font-weight: 600;
  transition: 0.18s ease;

  &:hover {
    color: #d90000;
    background: #fff5f5;
  }
`

export const Main = styled.main`
  min-width: 0;
`

export const Topbar = styled.header`
  min-height: 78px;
  padding: 14px 28px;
  border-bottom: 1px solid #e6e9ee;
  background: rgba(255, 255, 255, 0.96);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;

  @media (max-width: 720px) {
    min-height: 56px;
    padding: 9px 12px;
    align-items: center;
    flex-direction: row;
  }
`

export const TopbarEyebrow = styled.div`
  color: #d90000;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`

export const TopbarTitle = styled.div`
  margin-top: 2px;
  color: #202633;
  font-size: 20px;
  font-weight: 800;
`

export const UserArea = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`

export const UserAvatar = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f1f3;
  color: #737b88;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 720px) {
    width: 30px;
    height: 30px;
  }
`

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;

  strong {
    color: #262c36;
    font-size: 12px;
  }

  span {
    max-width: 220px;
    overflow: hidden;
    color: #8a92a0;
    font-size: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media (max-width: 720px) {
    display: none;
  }
`

export const AdminChip = styled.span`
  padding: 5px 8px;
  border-radius: 999px;
  background: #fff0f0;
  color: #d90000;
  font-size: 10px;
  font-weight: 800;

  @media (max-width: 720px) {
    display: none;
  }
`

export const SignOutButton = styled.button`
  width: 36px;
  height: 36px;
  border: 1px solid #e3e6eb;
  border-radius: 9px;
  background: #fff;
  color: #68707d;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    color: #d90000;
    border-color: rgba(217, 0, 0, 0.2);
    background: #fff7f7;
  }

  @media (max-width: 720px) {
    width: 30px;
    height: 30px;
  }
`

export const Content = styled.div`
  width: min(1120px, calc(100% - 48px));
  margin: 0 auto;
  padding: 56px 0 70px;

  @media (max-width: 720px) {
    width: calc(100% - 20px);
    padding: 18px 0 34px;
  }
`

export const WelcomeCard = styled.section`
  padding: 34px;
  border: 1px solid #e7e9ee;
  border-radius: 20px;
  background: #fff;
  display: flex;
  align-items: flex-start;
  gap: 22px;
  box-shadow: 0 12px 34px rgba(31, 38, 48, 0.05);

  @media (max-width: 620px) {
    padding: 24px;
    flex-direction: column;
  }
`

export const WelcomeIcon = styled.div`
  flex: 0 0 auto;
  width: 54px;
  height: 54px;
  border-radius: 16px;
  background: #fff0f0;
  color: #d90000;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 23px;
  }
`

export const WelcomeText = styled.div`
  span {
    color: #d90000;
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  h1 {
    margin: 5px 0 10px;
    color: #202633;
    font-size: clamp(26px, 4vw, 38px);
    line-height: 1.1;
  }

  p {
    max-width: 740px;
    margin: 0;
    color: #727b89;
    font-size: 14px;
    line-height: 1.7;
  }
`

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-top: 16px;

  @media (max-width: 880px) {
    grid-template-columns: 1fr;
  }
`

export const InfoCard = styled.div`
  padding: 22px;
  border: 1px solid #e7e9ee;
  border-radius: 16px;
  background: #fff;

  strong {
    display: block;
    margin-bottom: 7px;
    color: #2c323d;
    font-size: 14px;
  }

  p {
    margin: 0;
    color: #7c8491;
    font-size: 12px;
    line-height: 1.6;
  }
`

export const SidebarNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 5px;

  @media (max-width: 900px) {
    display: grid;
    grid-template-columns: repeat(5, minmax(140px, 1fr));
    overflow-x: auto;
  }

  @media (max-width: 720px) {
    grid-template-columns: repeat(5, minmax(105px, 1fr));
    gap: 4px;
    padding-bottom: 3px;
  }
`

export const SidebarNavItem = styled.div<{
  $active?: boolean
  $disabled?: boolean
}>`
  min-height: 43px;
  padding: 0 12px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${({ $active }) => ($active ? '#fff0f0' : 'transparent')};
  color: ${({ $active, $disabled }) =>
    $active ? '#d90000' : $disabled ? '#a3a9b2' : '#515866'};
  font-size: 12px;
  font-weight: ${({ $active }) => ($active ? 800 : 600)};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};

  svg {
    flex: 0 0 auto;
    font-size: 14px;
  }

  span {
    margin-left: auto;
    color: #b5bac2;
    font-size: 8px;
    font-weight: 700;
    text-transform: uppercase;
  }

  @media (max-width: 720px) {
    min-height: 34px;
    padding: 0 8px;
    font-size: 10px;

    svg {
      font-size: 11px;
    }

    span {
      display: none;
    }
  }
`

export const DashboardHeader = styled.div`
  margin-bottom: 18px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;

  h1 {
    margin: 0;
    color: #202633;
    font-size: 25px;
  }

  p {
    margin: 6px 0 0;
    color: #7a8390;
    font-size: 12px;
  }

  @media (max-width: 640px) {
    margin-bottom: 12px;
    align-items: center;
    flex-direction: row;

    h1 {
      font-size: 19px;
    }

    p {
      display: none;
    }
  }
`

export const PeriodSelect = styled.select`
  height: 38px;
  padding: 0 12px;
  border: 1px solid #dfe3e8;
  border-radius: 9px;
  background: #fff;
  color: #4e5663;
  font-size: 11px;
  font-weight: 600;
  outline: none;
`

export const StateCard = styled.div<{ $error?: boolean }>`
  padding: 18px;
  border: 1px solid ${({ $error }) => ($error ? '#f1cccc' : '#e3e6eb')};
  border-radius: 12px;
  background: ${({ $error }) => ($error ? '#fff5f5' : '#fff')};
  color: ${({ $error }) => ($error ? '#b50000' : '#6e7682')};
  font-size: 12px;
`

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 1120px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 620px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
`

export const SummaryCard = styled.article`
  min-height: 144px;
  padding: 18px;
  border: 1px solid #e2e6eb;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 7px 24px rgba(35, 42, 52, 0.035);

  > strong {
    display: block;
    margin-top: 12px;
    color: #202633;
    font-size: 27px;
    line-height: 1;
  }

  > span {
    display: block;
    margin-top: 6px;
    color: #4d5665;
    font-size: 12px;
    font-weight: 700;
  }

  > small {
    display: block;
    margin-top: 5px;
    color: #969da8;
    font-size: 9px;
  }

  @media (max-width: 620px) {
    min-height: 104px;
    padding: 12px;

    > strong {
      margin-top: 8px;
      font-size: 21px;
    }

    > span {
      margin-top: 4px;
      font-size: 10px;
      line-height: 1.2;
    }

    > small {
      margin-top: 3px;
      font-size: 8px;
      line-height: 1.25;
    }
  }
`

export const SummaryTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

export const IconBox = styled.div<{
  $tone: 'blue' | 'red' | 'green' | 'purple'
}>`
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $tone }) =>
    $tone === 'blue'
      ? '#e8f1ff'
      : $tone === 'red'
        ? '#ffe9e9'
        : $tone === 'green'
          ? '#e3f8ec'
          : '#f1e8ff'};
  color: ${({ $tone }) =>
    $tone === 'blue'
      ? '#2d6cdf'
      : $tone === 'red'
        ? '#e12626'
        : $tone === 'green'
          ? '#16a05d'
          : '#8c46d9'};

  @media (max-width: 620px) {
    width: 28px;
    height: 28px;

    svg {
      font-size: 12px;
    }
  }
`

export const Change = styled.span<{ $positive: boolean }>`
  color: ${({ $positive }) => ($positive ? '#159b57' : '#d74747')};
  font-size: 9px;
  font-weight: 800;
`

export const DashboardGrid = styled.div`
  display: grid;
  grid-template-columns: 1.55fr 1fr;
  gap: 14px;
  margin-top: 14px;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 720px) {
    gap: 8px;
    margin-top: 8px;
  }
`

export const Panel = styled.section<{ $wide?: boolean }>`
  min-width: 0;
  min-height: 280px;
  padding: 19px;
  border: 1px solid #e2e6eb;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 7px 24px rgba(35, 42, 52, 0.03);

  @media (max-width: 720px) {
    min-height: 0;
    padding: 13px;
    border-radius: 12px;
  }
`

export const PanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  h2 {
    margin: 0;
    color: #222936;
    font-size: 16px;
  }
  p {
    margin: 4px 0 0;
    color: #8b929d;
    font-size: 9px;
  }

  @media (max-width: 720px) {
    h2 {
      font-size: 13px;
    }

    p {
      font-size: 8px;
    }
  }
`

export const Legend = styled.div`
  display: flex;
  gap: 12px;
  color: #69717d;
  font-size: 9px;

  span {
    display: inline-flex;
    align-items: center;
    gap: 5px;
  }
  i {
    width: 7px;
    height: 7px;
    border-radius: 2px;
  }
  i.users {
    background: #e93434;
  }
  i.routes {
    background: #3ca8e0;
  }
`

export const GrowthChart = styled.div`
  height: 210px;
  margin-top: 22px;
  padding: 0 8px 4px;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  align-items: end;
  gap: 12px;
  border-bottom: 1px solid #edf0f4;

  @media (max-width: 720px) {
    height: 138px;
    margin-top: 12px;
    gap: 6px;
  }
`

export const GrowthColumn = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: 1fr auto;
  gap: 7px;

  > span {
    color: #8a929d;
    font-size: 9px;
    text-align: center;
    text-transform: capitalize;
  }
`

export const Bars = styled.div`
  height: 100%;
  display: flex;
  align-items: end;
  justify-content: center;
  gap: 4px;
`

export const Bar = styled.div<{
  $height: number
  $kind: 'users' | 'routes'
}>`
  width: min(18px, 38%);
  min-height: ${({ $height }) => ($height > 0 ? '4px' : '0')};
  height: ${({ $height }) => Math.max(0, $height)}%;
  border-radius: 4px 4px 1px 1px;
  background: ${({ $kind }) => ($kind === 'users' ? '#e93434' : '#3ca8e0')};
`

export const DonutArea = styled.div`
  min-height: 210px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;

  @media (max-width: 520px) {
    min-height: 128px;
    margin-top: 10px;
    flex-direction: row;
    gap: 18px;
  }
`

export const Donut = styled.div<{ $published: number }>`
  width: 144px;
  height: 144px;
  border-radius: 50%;
  background: ${({ $published }) =>
    `conic-gradient(#e93434 0 ${$published}%, #e8edf2 ${$published}% 100%)`};
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    width: 94px;
    height: 94px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  strong {
    color: #202633;
    font-size: 22px;
  }
  span {
    color: #959ca7;
    font-size: 8px;
    text-transform: uppercase;
  }

  @media (max-width: 520px) {
    width: 96px;
    height: 96px;

    > div {
      width: 64px;
      height: 64px;
    }

    strong {
      font-size: 16px;
    }
  }
`

export const DonutLegend = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;

  > div {
    display: flex;
    align-items: center;
    gap: 9px;
  }
  > div > span {
    width: 9px;
    height: 9px;
    border-radius: 3px;
  }
  span.published {
    background: #e93434;
  }
  span.planned {
    background: #e8edf2;
  }
  p {
    margin: 0;
    color: #747d89;
    font-size: 9px;
  }
  strong {
    display: block;
    color: #2c3340;
    font-size: 13px;
  }
`

export const EngagementGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 18px;

  @media (max-width: 720px) {
    gap: 7px;
    margin-top: 10px;
  }
`

export const EngagementItem = styled.div`
  min-height: 88px;
  padding: 14px;
  border: 1px solid #edf0f4;
  border-radius: 11px;
  display: flex;
  align-items: center;
  gap: 11px;
  background: #fbfcfd;

  > svg {
    color: #e93434;
    font-size: 17px;
  }
  strong {
    display: block;
    color: #272e39;
    font-size: 17px;
  }
  span {
    display: block;
    color: #9299a3;
    font-size: 9px;
  }

  @media (max-width: 720px) {
    min-height: 62px;
    padding: 9px;
    gap: 8px;

    > svg {
      font-size: 13px;
    }

    strong {
      font-size: 14px;
    }

    span {
      font-size: 8px;
    }
  }
`

export const RankingList = styled.div`
  margin-top: 14px;
  display: flex;
  flex-direction: column;
`

export const RankingItem = styled.div`
  min-height: 42px;
  border-bottom: 1px solid #f0f2f5;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;

  b {
    color: #b2b8c1;
    font-size: 11px;
  }
  span {
    overflow: hidden;
    color: #454d59;
    font-size: 10px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  strong {
    color: #188f53;
    font-size: 9px;
  }

  @media (max-width: 720px) {
    min-height: 34px;
    grid-template-columns: 22px minmax(0, 1fr) auto;

    b {
      font-size: 9px;
    }

    span {
      font-size: 9px;
    }

    strong {
      font-size: 8px;
    }
  }
`

export const ActivityList = styled.div`
  margin-top: 11px;
  display: flex;
  flex-direction: column;
`

export const ActivityItem = styled.div`
  min-height: 54px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f2f5;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;

  > div:nth-child(2) {
    min-width: 0;
    strong {
      display: block;
      overflow: hidden;
      color: #3b4350;
      font-size: 10px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    span {
      display: block;
      color: #969ca6;
      font-size: 8px;
    }
  }

  small {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #a2a8b1;
    font-size: 8px;
  }

  @media (max-width: 720px) {
    min-height: 44px;
    padding: 5px 0;
    grid-template-columns: 28px minmax(0, 1fr) auto;
    gap: 7px;

    small {
      font-size: 7px;
    }
  }
`

export const ActivityIcon = styled.div<{
  $type: 'user' | 'itinerary'
}>`
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $type }) => ($type === 'user' ? '#e8f1ff' : '#ffe9e9')};
  color: ${({ $type }) => ($type === 'user' ? '#2d6cdf' : '#e12626')};

  @media (max-width: 720px) {
    width: 26px;
    height: 26px;
    font-size: 10px;
  }
`

export const EmptyText = styled.div`
  padding: 26px 0;
  color: #979ea8;
  font-size: 10px;
  text-align: center;
`

export const FutureSection = styled.section`
  margin-top: 14px;
  padding: 21px;
  border: 1px dashed #d9dde3;
  border-radius: 14px;
  background: #fbfcfd;

  @media (max-width: 720px) {
    margin-top: 8px;
    padding: 13px;
    border-radius: 12px;
  }
`

export const FutureHeader = styled.div`
  h2 {
    margin: 4px 0 0;
    color: #2a313d;
    font-size: 16px;
  }
  p {
    margin: 6px 0 0;
    color: #8a929d;
    font-size: 9px;
  }

  @media (max-width: 720px) {
    h2 {
      font-size: 13px;
    }

    p {
      display: none;
    }
  }
`

export const FutureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-top: 16px;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 560px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 7px;
    margin-top: 10px;
  }
`

export const FutureCard = styled.div`
  min-height: 128px;
  padding: 16px;
  border: 1px solid #ebedf1;
  border-radius: 11px;
  background: #fff;

  svg {
    color: #d90000;
    font-size: 16px;
  }
  strong {
    display: block;
    margin-top: 10px;
    color: #3f4652;
    font-size: 11px;
  }
  span {
    display: block;
    margin-top: 5px;
    color: #9299a3;
    font-size: 9px;
    line-height: 1.55;
  }

  @media (max-width: 560px) {
    min-height: 86px;
    padding: 10px;

    svg {
      font-size: 13px;
    }

    strong {
      margin-top: 7px;
      font-size: 10px;
      line-height: 1.2;
    }

    span {
      margin-top: 3px;
      font-size: 8px;
      line-height: 1.35;
    }
  }
`

export const SidebarNavLink = styled(Link)<{ $active?: boolean }>`
  min-height: 43px;
  padding: 0 12px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${({ $active }) => ($active ? '#fff0f0' : 'transparent')};
  color: ${({ $active }) => ($active ? '#d90000' : '#515866')};
  font-size: 12px;
  font-weight: ${({ $active }) => ($active ? 800 : 600)};
  transition: 0.18s ease;

  svg {
    flex: 0 0 auto;
    font-size: 14px;
  }

  &:hover {
    color: #d90000;
    background: #fff5f5;
  }

  @media (max-width: 900px) {
    min-width: 145px;
  }

  @media (max-width: 720px) {
    min-width: 105px;
    min-height: 34px;
    padding: 0 8px;
    font-size: 10px;

    svg {
      font-size: 11px;
    }
  }
`

export const UserSummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 14px;

  @media (max-width: 1020px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 580px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 10px;
  }
`

export const UserSummaryCard = styled.div<{
  $tone?: 'green' | 'blue' | 'red'
}>`
  min-height: 92px;
  padding: 16px;
  border: 1px solid #e3e7ec;
  border-radius: 13px;
  display: flex;
  align-items: center;
  gap: 13px;
  background: #fff;

  > svg {
    width: 34px;
    height: 34px;
    padding: 9px;
    border-radius: 10px;
    background: ({ $tone }) =>
      $tone === 'green'
        ? '#e8f8ef'
        : $tone === 'blue'
          ? '#eaf2ff'
          : $tone === 'red'
            ? '#fff0f0'
            : '#f3f4f6';
    color: ({ $tone }) =>
      $tone === 'green'
        ? '#189555'
        : $tone === 'blue'
          ? '#3473d8'
          : $tone === 'red'
            ? '#d82424'
            : '#646d79';
  }

  strong {
    display: block;
    color: #252c37;
    font-size: 22px;
  }

  span {
    display: block;
    margin-top: 2px;
    color: #808894;
    font-size: 10px;
  }

  @media (max-width: 580px) {
    min-height: 76px;
    padding: 10px;
    gap: 9px;

    > svg {
      width: 28px;
      height: 28px;
      padding: 7px;
    }

    strong {
      font-size: 18px;
    }

    span {
      font-size: 8px;
      line-height: 1.2;
    }
  }
`

export const UserToolbar = styled.div`
  margin-bottom: 14px;
  padding: 12px;
  border: 1px solid #e3e7ec;
  border-radius: 13px;
  display: grid;
  grid-template-columns: minmax(260px, 1fr) 190px 190px;
  gap: 10px;
  background: #fff;

  @media (max-width: 880px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 580px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 7px;
    margin-bottom: 10px;
    padding: 9px;

    > input:first-child {
      grid-column: 1 / -1;
    }
  }
`

export const UserSearchInput = styled.input`
  height: 39px;
  padding: 0 12px;
  border: 1px solid #dfe3e8;
  border-radius: 9px;
  outline: none;
  color: #343b46;
  font-size: 11px;

  &:focus {
    border-color: rgba(217, 0, 0, 0.45);
    box-shadow: 0 0 0 3px rgba(217, 0, 0, 0.06);
  }
`

export const UserFilter = styled.select`
  height: 39px;
  padding: 0 10px;
  border: 1px solid #dfe3e8;
  border-radius: 9px;
  outline: none;
  background: #fff;
  color: #4d5561;
  font-size: 10px;
`

export const UserTableCard = styled.div`
  overflow: hidden;
  border: 1px solid #e3e7ec;
  border-radius: 13px;
  background: #fff;
`

export const UserTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    padding: 12px 10px;
    border-bottom: 1px solid #eef1f4;
    text-align: left;
    vertical-align: middle;
  }

  th {
    color: #78818e;
    font-size: 9px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    background: #fbfcfd;
  }

  td {
    color: #59616d;
    font-size: 10px;
  }

  th:first-child,
  td:first-child {
    width: 27%;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 9%;
  }

  th:nth-child(3),
  td:nth-child(3) {
    width: 11%;
  }

  th:nth-child(4),
  td:nth-child(4),
  th:nth-child(5),
  td:nth-child(5) {
    width: 8%;
  }

  th:nth-child(6),
  td:nth-child(6) {
    width: 15%;
  }

  th:nth-child(7),
  td:nth-child(7) {
    width: 10%;
  }

  th:last-child,
  td:last-child {
    width: 12%;
    text-align: right;
  }

  tbody tr:hover {
    background: #fcfcfd;
  }

  @media (max-width: 1000px) {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
    table-layout: auto;
  }

  @media (max-width: 680px) {
    display: none;
  }
`

export const UserIdentity = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 9px;

  > div:last-child {
    min-width: 0;
  }

  strong {
    display: block;
    overflow: hidden;
    color: #303743;
    font-size: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    display: block;
    margin-top: 2px;
    overflow: hidden;
    color: #9299a4;
    font-size: 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const TableAvatar = styled.div`
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
  color: #9299a4;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const RoleChip = styled.span<{ $admin?: boolean }>`
  display: inline-flex;
  padding: 4px 7px;
  border: 1px solid ${({ $admin }) => ($admin ? '#f2c8c8' : '#dce1e6')};
  border-radius: 999px;
  background: ${({ $admin }) => ($admin ? '#fff2f2' : '#f7f8f9')};
  color: ${({ $admin }) => ($admin ? '#ca1b1b' : '#626b77')};
  font-size: 8px;
  font-weight: 800;
`

export const StatusChip = styled.span<{
  $status: 'active' | 'suspended' | 'banned'
}>`
  display: inline-flex;
  padding: 4px 7px;
  border-radius: 999px;
  background: ({ $status }) =>
    $status === 'active'
      ? '#e9f9ef'
      : $status === 'suspended'
        ? '#fff7df'
        : '#fff0f0';
  color: ({ $status }) =>
    $status === 'active'
      ? '#178d50'
      : $status === 'suspended'
        ? '#a66a00'
        : '#c71d1d';
  font-size: 8px;
  font-weight: 800;
`

export const VerifiedMark = styled.span`
  margin-left: 5px;
  color: #3473d8;
  font-size: 10px;
`

export const TableAction = styled.button`
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid #dde2e7;
  border-radius: 8px;
  background: #fff;
  color: #515965;
  font-size: 9px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    color: #d90000;
    border-color: rgba(217, 0, 0, 0.22);
    background: #fff8f8;
  }
`

export const Pagination = styled.div`
  min-height: 52px;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  color: #8c949f;
  font-size: 9px;

  > div {
    display: flex;
    gap: 7px;
  }

  button {
    min-height: 30px;
    padding: 0 10px;
    border: 1px solid #dde2e7;
    border-radius: 8px;
    background: #fff;
    color: #59616d;
    font-size: 9px;
    font-weight: 700;
    cursor: pointer;
  }

  button:disabled {
    opacity: 0.4;
    cursor: default;
  }

  @media (max-width: 580px) {
    min-height: 46px;
    padding: 8px;
    font-size: 8px;

    button {
      min-height: 28px;
      padding: 0 8px;
      font-size: 8px;
    }
  }
`

export const AdminModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(20, 24, 31, 0.58);
  backdrop-filter: blur(5px);

  @media (max-width: 580px) {
    padding: 10px;
    align-items: flex-end;
  }
`

export const AdminModal = styled.div`
  width: min(760px, 100%);
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  padding: 22px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.24);

  @media (max-width: 580px) {
    width: 100%;
    max-height: 91vh;
    padding: 14px;
    border-radius: 20px 20px 12px 12px;
    overscroll-behavior: contain;
  }
`

export const AdminModalHeader = styled.div`
  position: sticky;
  top: -14px;
  z-index: 4;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 10px;
  background: #fff;

  h2 {
    margin: 3px 0 0;
    color: #252c37;
    font-size: 20px;
  }

  > button {
    flex: 0 0 auto;
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: 50%;
    background: #f3f4f6;
    color: #666e79;
    font-size: 18px;
    cursor: pointer;
  }

  @media (max-width: 580px) {
    top: -14px;
    margin: -2px -2px 0;
    padding: 2px 2px 10px;

    h2 {
      font-size: 17px;
    }
  }
`

export const AdminUserHero = styled.div`
  margin-top: 10px;
  padding: 14px;
  border: 1px solid #e8ebef;
  border-radius: 13px;
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  background: #fbfcfd;

  h3 {
    margin: 0;
    color: #303743;
    font-size: 15px;
  }

  p {
    margin: 3px 0 0;
    overflow-wrap: anywhere;
    color: #717a86;
    font-size: 10px;
  }

  span {
    display: block;
    margin-top: 4px;
    color: #9aa1aa;
    font-size: 8px;
  }

  @media (max-width: 580px) {
    grid-template-columns: 46px minmax(0, 1fr) auto;
    padding: 12px;
    gap: 10px;

    h3 {
      font-size: 14px;
    }

    p {
      font-size: 9px;
    }

    span {
      font-size: 7px;
      line-height: 1.35;
    }
  }
`

export const AdminUserAvatar = styled.div`
  width: 52px;
  height: 52px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #edf0f3;
  color: #7f8792;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 580px) {
    width: 46px;
    height: 46px;
  }
`

export const AdminUserStats = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-top: 10px;

  > div {
    padding: 12px;
    border: 1px solid #eceff2;
    border-radius: 10px;
    background: #fff;
  }

  strong {
    display: block;
    color: #313844;
    font-size: 16px;
  }

  span {
    display: block;
    margin-top: 2px;
    color: #969da7;
    font-size: 8px;
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 7px;
    margin-top: 8px;

    > div {
      min-height: 66px;
      padding: 10px;
    }

    strong {
      font-size: 14px;
    }

    span {
      font-size: 7px;
      line-height: 1.25;
    }
  }
`

export const ModerationForm = styled.div`
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  label {
    display: flex;
    flex-direction: column;
    gap: 6px;
    color: #555e6b;
    font-size: 9px;
    font-weight: 700;
  }

  label:last-child {
    grid-column: 1 / -1;
  }

  select,
  textarea {
    width: 100%;
    border: 1px solid #dfe3e8;
    border-radius: 10px;
    background: #fff;
    color: #3f4752;
    font-family: inherit;
    font-size: 10px;
    outline: none;
  }

  select {
    height: 40px;
    padding: 0 10px;
  }

  textarea {
    min-height: 78px;
    padding: 10px;
    resize: vertical;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 9px;

    label {
      font-size: 8px;
    }

    textarea {
      min-height: 72px;
    }
  }
`

export const CheckLabel = styled.label`
  min-height: 42px;
  padding: 0 10px;
  border: 1px solid #e3e7ec;
  border-radius: 10px;
  display: flex !important;
  flex-direction: row !important;
  align-items: center;
  justify-content: flex-start;
  gap: 9px !important;
  background: #fafbfc;
  color: #4e5763 !important;
  cursor: pointer;

  input[type='checkbox'] {
    flex: 0 0 auto;
    width: 17px;
    height: 17px;
    margin: 0;
    accent-color: #d90000;
  }

  @media (max-width: 600px) {
    min-height: 44px;
    padding: 0 11px;
    font-size: 9px !important;
  }
`

export const AdminNotice = styled.div`
  margin-top: 10px;
  padding: 10px 12px;
  border-left: 3px solid #d90000;
  border-radius: 0 9px 9px 0;
  background: #fff5f5;
  color: #7f5555;
  font-size: 9px;
`

export const AdminActivity = styled.div`
  margin-top: 12px;

  h3 {
    margin: 0 0 8px;
    color: #343b46;
    font-size: 13px;
  }

  > div {
    min-height: 42px;
    padding: 8px 0;
    border-bottom: 1px solid #eef1f4;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
    align-items: center;
    gap: 8px;
  }

  strong {
    color: #515966;
    font-size: 9px;
  }

  span {
    overflow: hidden;
    color: #9198a2;
    font-size: 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  small {
    color: #a0a7b0;
    font-size: 8px;
  }

  @media (max-width: 580px) {
    h3 {
      margin-bottom: 5px;
      font-size: 12px;
    }

    > div {
      min-height: 36px;
      padding: 6px 0;
      grid-template-columns: minmax(0, 1fr) auto;
      gap: 5px;

      span {
        display: none;
      }
    }

    strong {
      font-size: 8px;
    }

    small {
      font-size: 7px;
    }
  }
`

export const AdminModalActions = styled.div`
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;

  a,
  button {
    min-height: 36px;
    padding: 0 13px;
    border: 1px solid #dde2e7;
    border-radius: 9px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: #555e69;
    font-size: 9px;
    font-weight: 800;
    cursor: pointer;
  }

  a {
    margin-right: auto;
  }

  button.primary {
    border-color: #d90000;
    background: #d90000;
    color: #fff;
  }

  button.danger {
    gap: 6px;
    border-color: #efcccc;
    background: #fff6f6;
    color: #c71d1d;
  }

  button.danger:hover {
    border-color: #d90000;
    background: #fff0f0;
  }

  button:disabled {
    opacity: 0.6;
    cursor: wait;
  }

  @media (max-width: 580px) {
    position: sticky;
    bottom: -14px;
    z-index: 3;
    margin: 12px -14px -14px;
    padding: 10px 14px 14px;
    border-top: 1px solid #eceff2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    background: #fff;

    a,
    button {
      min-height: 40px;
      margin: 0;
      padding: 0 10px;
      font-size: 9px;
    }

    a {
      grid-column: 1 / -1;
    }

    button.primary {
      grid-column: 2;
    }
  }
`

export const ItineraryAdminTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    padding: 12px 10px;
    border-bottom: 1px solid #eef1f4;
    text-align: left;
    vertical-align: middle;
  }

  th {
    background: #fbfcfd;
    color: #78818e;
    font-size: 9px;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  td {
    color: #59616d;
    font-size: 10px;
  }

  th:first-child,
  td:first-child {
    width: 27%;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 18%;
  }

  th:nth-child(3),
  td:nth-child(3),
  th:nth-child(4),
  td:nth-child(4) {
    width: 10%;
  }

  th:nth-child(5),
  td:nth-child(5) {
    width: 17%;
  }

  th:nth-child(6),
  td:nth-child(6) {
    width: 10%;
  }

  th:last-child,
  td:last-child {
    width: 8%;
    text-align: right;
  }

  tbody tr:hover {
    background: #fcfcfd;
  }

  @media (max-width: 1100px) {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
    table-layout: auto;
  }
`

export const ItineraryIdentity = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;

  > div:last-child {
    min-width: 0;
  }

  strong {
    display: block;
    overflow: hidden;
    color: #303743;
    font-size: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    display: block;
    margin-top: 3px;
    color: #9299a4;
    font-size: 8px;
  }
`

export const ItineraryThumb = styled.div`
  flex: 0 0 auto;
  width: 54px;
  height: 38px;
  overflow: hidden;
  border-radius: 8px;
  background: #eceff2;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const ItineraryAuthor = styled.div`
  min-width: 0;

  strong {
    display: block;
    overflow: hidden;
    color: #434b57;
    font-size: 9px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    display: block;
    margin-top: 3px;
    overflow: hidden;
    color: #969da7;
    font-size: 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const TripChip = styled.span<{ $made: boolean }>`
  display: inline-flex;
  padding: 4px 7px;
  border-radius: 999px;
  background: ${({ $made }) => ($made ? '#e9f9ef' : '#eef3ff')};
  color: ${({ $made }) => ($made ? '#168b4e' : '#496caf')};
  font-size: 8px;
  font-weight: 800;
`

export const ModerationChip = styled.span<{
  $status: 'visible' | 'hidden'
}>`
  display: inline-flex;
  padding: 4px 7px;
  border-radius: 999px;
  background: ${({ $status }) =>
    $status === 'visible' ? '#e9f9ef' : '#fff0f0'};
  color: ${({ $status }) => ($status === 'visible' ? '#168b4e' : '#c71d1d')};
  font-size: 8px;
  font-weight: 800;
`

export const EngagementInline = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;

  span {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #777f8a;
    font-size: 8px;
  }

  svg {
    color: #a1a8b1;
    font-size: 9px;
  }
`

export const ItineraryDetailHero = styled.div`
  margin-top: 18px;
  padding: 14px;
  border: 1px solid #e8ebef;
  border-radius: 13px;
  display: grid;
  grid-template-columns: 132px minmax(0, 1fr);
  align-items: center;
  gap: 15px;
  background: #fbfcfd;

  h3 {
    margin: 8px 0 4px;
    color: #2d3440;
    font-size: 17px;
    line-height: 1.25;
  }

  p {
    margin: 0;
    color: #7e8793;
    font-size: 9px;
  }

  p a {
    color: #d90000;
    font-weight: 700;
  }

  > div:last-child > span {
    display: block;
    margin-top: 6px;
    color: #959ca6;
    font-size: 8px;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`

export const ItineraryDetailCover = styled.div`
  width: 132px;
  height: 92px;
  overflow: hidden;
  border-radius: 10px;
  background: #eceff2;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 560px) {
    width: 100%;
    height: 150px;
  }
`

export const ItinerarySummaryBox = styled.div`
  margin-top: 12px;
  padding: 13px;
  border: 1px solid #eceff2;
  border-radius: 10px;
  background: #fff;

  > strong {
    display: block;
    color: #444c58;
    font-size: 10px;
  }

  > p {
    margin: 6px 0 0;
    color: #7e8691;
    font-size: 9px;
    line-height: 1.65;
    white-space: pre-wrap;
  }
`

export const ItineraryDetailGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 12px;

  > div {
    padding: 13px;
    border: 1px solid #eceff2;
    border-radius: 10px;
    background: #fff;
  }

  h3 {
    margin: 0 0 9px;
    color: #444c58;
    font-size: 10px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

export const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;

  span {
    padding: 5px 7px;
    border-radius: 999px;
    background: #f3f5f7;
    color: #646d79;
    font-size: 8px;
  }

  em {
    color: #9aa1aa;
    font-size: 8px;
    font-style: normal;
  }
`

export const CollaboratorList = styled.div`
  margin-top: 7px;
  display: flex;
  flex-direction: column;
  gap: 5px;

  span {
    color: #747d89;
    font-size: 8px;
  }
`

export const MobileUserList = styled.div`
  display: none;

  @media (max-width: 680px) {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
    background: #f7f9fb;
  }
`

export const MobileUserCard = styled.article`
  padding: 12px;
  border: 1px solid #e4e8ed;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(35, 42, 52, 0.025);
`

export const MobileUserHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`

export const MobileUserBadges = styled.div`
  margin-top: 9px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
`

export const MobileVerifiedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border-radius: 999px;
  background: #eef4ff;
  color: #3473d8;
  font-size: 8px;
  font-weight: 800;
`

export const MobileUserMetrics = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: 0.8fr 0.8fr 1.4fr;
  gap: 6px;

  > div {
    min-width: 0;
    padding: 8px;
    border-radius: 9px;
    background: #f7f9fb;
  }

  strong {
    display: block;
    overflow: hidden;
    color: #2f3743;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    display: block;
    margin-top: 2px;
    color: #949ba5;
    font-size: 7px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
`

export const MobileUserActivity = styled.div`
  margin-top: 9px;
  padding-top: 8px;
  border-top: 1px solid #eef1f4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  span {
    color: #9aa1aa;
    font-size: 8px;
  }

  strong {
    overflow: hidden;
    color: #626b77;
    font-size: 8px;
    font-weight: 700;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const LocalityTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    padding: 12px 10px;
    border-bottom: 1px solid #eef1f4;
    text-align: left;
    vertical-align: middle;
  }

  th {
    background: #fbfcfd;
    color: #78818e;
    font-size: 9px;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  td {
    color: #59616d;
    font-size: 10px;
  }

  th:first-child,
  td:first-child {
    width: 36%;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 16%;
  }

  th:nth-child(3),
  td:nth-child(3) {
    width: 18%;
  }

  th:nth-child(4),
  td:nth-child(4),
  th:nth-child(5),
  td:nth-child(5) {
    width: 10%;
  }

  th:last-child,
  td:last-child {
    width: 10%;
    text-align: right;
  }

  @media (max-width: 680px) {
    display: none;
  }
`

export const LocalityIdentity = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 9px;

  > svg {
    flex: 0 0 auto;
    color: #d90000;
    font-size: 16px;
  }

  > div {
    min-width: 0;
  }

  strong {
    display: block;
    overflow: hidden;
    color: #303743;
    font-size: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    display: block;
    margin-top: 2px;
    color: #9299a4;
    font-size: 8px;
  }
`

export const LocalityFeatured = styled.span`
  margin-left: 5px;
  padding: 4px 7px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #fff8df;
  color: #a66a00;
  font-size: 8px;
  font-weight: 800;

  svg {
    font-size: 8px;
  }
`

export const MobileLocalityList = styled.div`
  display: none;

  @media (max-width: 680px) {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
    background: #f7f9fb;
  }
`

export const MobileLocalityCard = styled.article`
  padding: 12px;
  border: 1px solid #e4e8ed;
  border-radius: 12px;
  background: #ffffff;
`

export const MobileLocalityHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`

export const MobileLocalityMetrics = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;

  > div {
    min-width: 0;
    padding: 8px;
    border-radius: 9px;
    background: #f7f9fb;
  }

  strong {
    display: block;
    color: #2f3743;
    font-size: 12px;
  }

  span {
    display: block;
    margin-top: 2px;
    color: #949ba5;
    font-size: 7px;
    line-height: 1.2;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
`

export const LocalityHero = styled.div`
  margin-top: 10px;
  padding: 14px;
  border: 1px solid #e8ebef;
  border-radius: 13px;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  align-items: center;
  gap: 11px;
  background: #fbfcfd;

  > svg {
    width: 42px;
    height: 42px;
    padding: 11px;
    border-radius: 12px;
    background: #fff0f0;
    color: #d90000;
  }

  h3 {
    margin: 0;
    color: #303743;
    font-size: 15px;
  }

  p {
    margin: 3px 0 0;
    color: #717a86;
    font-size: 9px;
  }

  span {
    display: block;
    margin-top: 4px;
    color: #9aa1aa;
    font-size: 8px;
  }
`

export const LocalityForm = styled.div`
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  label {
    display: flex;
    flex-direction: column;
    gap: 6px;
    color: #555e6b;
    font-size: 9px;
    font-weight: 700;
  }

  label.wide {
    grid-column: 1 / -1;
  }

  input,
  select,
  textarea {
    width: 100%;
    border: 1px solid #dfe3e8;
    border-radius: 10px;
    background: #fff;
    color: #3f4752;
    font-family: inherit;
    font-size: 10px;
    outline: none;
  }

  input,
  select {
    height: 40px;
    padding: 0 10px;
  }

  textarea {
    min-height: 80px;
    padding: 10px;
    resize: vertical;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 9px;

    label.wide {
      grid-column: auto;
    }
  }
`

export const LocalityRouteList = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 7px;

  > a {
    padding: 9px 0;
    border-bottom: 1px solid #eef1f4;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    color: inherit;
  }

  > a:last-child {
    border-bottom: 0;
  }

  strong {
    display: block;
    color: #444c58;
    font-size: 9px;
  }

  span {
    display: block;
    margin-top: 2px;
    color: #9198a2;
    font-size: 8px;
  }
`
